<template>
	<el-drawer :wrapperClosable="false" :visible.sync="ruleDialogVisble" size="20%" :show-close="false">
		<template #title>
			<div style="height: 50px">
				<drawer-header :title="title" :is-add="false" @close="handleClose" />
			</div>
		</template>
		<div style="margin: 20px;">
			<el-row>
				<el-col>
					<span>规则时段：</span>
					<span
						style="text-align: center; font-size: 16px; color: #1a1a1a; background: #dee4ed; padding: 5px;">{{ruleDay}}</span>
				</el-col>
				<el-col style="margin-top: 30px;">
					<span>规则时组：</span>
					<strong v-for="(item,index) in times" :key="index"  style="display: inline-block; margin-left: 20px; margin-bottom: 20px;">
						{{item}}
					</strong>
				</el-col>
			</el-row>
		</div>
	</el-drawer>
</template>

<script>
	import DrawerHeader from "@/components/drawerHeader.vue"
	export default {
		components: {
			DrawerHeader
		},
		data() {
			return {
				title: "时段详情",
				ruleDialogVisble: false,
				//规则区间
				ruleDay: '',
				//规则区间时段组
				times: []
			}
		},
		methods: {
			show(obj) {
				this.ruleDay = obj.startDate.concat("~",obj.endDate)
				let timeArr = obj.rule.intervals.map(item =>{
					return item[0].concat("~",item[1])
				})
				this.times = timeArr
				console.log(this.times)
				this.ruleDialogVisble = true;
			},
			handleClose() {
				this.ruleDialogVisble = false;
			}
		}
	}
</script>

<style>
</style>